import { createFileRoute, useNavigate } from '@tanstack/react-router';

import Button from '@mui/material/Button';

import { paths } from 'src/routes/paths';
import { Iconify } from 'src/components/iconify';
import IntegrationsListComponent from 'src/components/settings/IntegrationsList';

export const Route = createFileRoute('/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/')({
  component: ClientIntegrationsDetail,
});

function ClientIntegrationsDetail() {
  const navigate = useNavigate();
  const { orgId } = Route.useParams();

  return (
    <>
      <Button
        size="small"
        startIcon={<Iconify icon="eva:arrow-back-fill" width={16} />}
        onClick={() => navigate({ to: paths.dashboard.orgSettings(orgId).client.brandIntegrations })}
        sx={{ mb: 2, textTransform: 'none' }}
      >
        All Clients
      </Button>
      <IntegrationsListComponent />
    </>
  );
}
